import React from 'react';
import OCRReader from './components/OCRReader';

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <OCRReader />
    </div>
  );
}

export default App;
